export const featuredTestimonials = [
  {
    initials: 'TM',
    text: 'Un gain de temps énorme. J’ai attaqué le lundi avec tout prêt, sans me prendre la tête. Je recommande vivement.',
    author: 'Thomas M.',
    role: 'Coach fonctionnel · Lyon',
    bg: 'bg-blue-600',
  },
  {
    initials: 'CL',
    text: 'J’avais des doutes avant d’acheter, mais j’ai été bluffée. Avec les trois versions, je gère mes groupes mixtes sans problème.',
    author: 'Camille L.',
    role: 'Instructrice · Bordeaux',
    bg: 'bg-sky-600',
  },
  {
    initials: 'JB',
    text: 'J’ai planifié mes cours avec de vraies progressions pour mes adhérents et ça se voit. Je le recommande sans hésiter.',
    author: 'Julien B.',
    role: 'Coach de box · Marseille',
    bg: 'bg-indigo-600',
  },
]

export const coachTestimonials = [
  {
    initials: 'ÉD',
    name: 'Émilie D.',
    location: 'Paris',
    product: 'A acheté le pack',
    text: 'Avant, j’arrivais épuisée le lundi. Maintenant j’ouvre le tome et en 5 minutes mon cours est prêt.',
    bg: 'bg-blue-600',
  },
  {
    initials: 'NR',
    name: 'Nicolas R.',
    location: 'Lille',
    product: 'A acheté le pack',
    text: 'Je l’ai acheté un peu méfiant et j’ai été surpris\u00a0: c’est bien plus complet que ce que j’imaginais.',
    bg: 'bg-sky-600',
  },
  {
    initials: 'SM',
    name: 'Sarah M.',
    location: 'Toulouse',
    product: 'A acheté le pack',
    text: 'Les échauffements et les retours au calme m’ont sauvée. Mes cours ont enfin une vraie structure du début à la fin.',
    bg: 'bg-indigo-600',
  },
  {
    initials: 'AG',
    name: 'Antoine G.',
    location: 'Nantes',
    product: 'A acheté le pack',
    text: 'Je commençais à manquer d’idées et ce pack est tombé à pic. Les séances sont complètes, variées et adaptées à chaque niveau.',
    bg: 'bg-blue-600',
  },
]
